define("shared/components/shared/profile-avatar", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@glimmer/tracking", "@ember/object", "ember-concurrency-decorators", "later/helpers/profile-color-outline-class", "later/utils/object-promise-proxy"], function (_exports, _component, _templateFactory, _component2, _tracking, _object, _emberConcurrencyDecorators, _profileColorOutlineClass, _objectPromiseProxy) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/object",0,"ember-concurrency-decorators",0,"later/helpers/profile-color-outline-class",0,"later/utils/object-promise-proxy",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="{{this.sizeClass}} {{this.outlineClass}} {{this.disabledClass}}" 
  {{did-insert this.setInitialAvatarUrl}}
  data-uid={{@socialProfile.uid}}
  data-profile-type={{@socialProfile.platformAbbreviation}} 
  ...attributes>
    {{#if this.avatarUrl}}
      <span class="o--user__avatarProfile">
        <img
          src={{this.avatarUrl}}
          alt={{@socialProfile.displayNickname}}
          draggable="false"
          ondragstart="return false;"
          class="o--user__avatar {{@avatarClass}}"
          onerror={{perform this.handleError}}
          data-test-avatar
        >
      </span>
    {{else}}
      <span>
        <img
          src="/assets/images/img--userAvatar--placeholder.svg"
          alt={{@socialProfile.displayNickname}}
          draggable="false"
          ondragstart="return false;"
          class="o--user__avatar {{@avatarClass}}"
          data-test-avatar-placeholder
        >
      </span>
    {{/if}}
  
    {{#if @showPlatform}}
      <span class={{concat "o--user__avatarChild--" @socialProfile.cssHandle}}>
        <i class={{concat "i--" @socialProfile.cssHandle "--w"}}></i>
      </span>
    {{/if}}
  
    {{#if @showDetails}}
      <span class="o--user__title">
        <span class="u--ellipsis {{@handleQaClass}}">
          {{@socialProfile.displayNickname}}
        </span>
      </span>
      <span class="o--user__desc">
        {{@socialProfile.accountType}}
        {{#if @showProfileType}}
          | {{if @socialProfile.isLinkedinPersonalProfile (t "shared_words.profile") (t "linkedin.page")}}
        {{/if}}
      </span>
    {{/if}}
  
    {{yield}}
  </div>
  
  */
  {
    "id": "x7ypa7HU",
    "block": "[[[11,0],[16,0,[29,[[30,0,[\"sizeClass\"]],\" \",[30,0,[\"outlineClass\"]],\" \",[30,0,[\"disabledClass\"]]]]],[16,\"data-uid\",[30,1,[\"uid\"]]],[16,\"data-profile-type\",[30,1,[\"platformAbbreviation\"]]],[17,2],[4,[38,0],[[30,0,[\"setInitialAvatarUrl\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"avatarUrl\"]],[[[1,\"    \"],[10,1],[14,0,\"o--user__avatarProfile\"],[12],[1,\"\\n      \"],[10,\"img\"],[15,\"src\",[30,0,[\"avatarUrl\"]]],[15,\"alt\",[30,1,[\"displayNickname\"]]],[14,\"draggable\",\"false\"],[14,\"ondragstart\",\"return false;\"],[15,0,[29,[\"o--user__avatar \",[30,3]]]],[15,\"onerror\",[28,[37,2],[[30,0,[\"handleError\"]]],null]],[14,\"data-test-avatar\",\"\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,1],[12],[1,\"\\n      \"],[10,\"img\"],[14,\"src\",\"/assets/images/img--userAvatar--placeholder.svg\"],[15,\"alt\",[30,1,[\"displayNickname\"]]],[14,\"draggable\",\"false\"],[14,\"ondragstart\",\"return false;\"],[15,0,[29,[\"o--user__avatar \",[30,3]]]],[14,\"data-test-avatar-placeholder\",\"\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[30,4],[[[1,\"    \"],[10,1],[15,0,[28,[37,3],[\"o--user__avatarChild--\",[30,1,[\"cssHandle\"]]],null]],[12],[1,\"\\n      \"],[10,\"i\"],[15,0,[28,[37,3],[\"i--\",[30,1,[\"cssHandle\"]],\"--w\"],null]],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,5],[[[1,\"    \"],[10,1],[14,0,\"o--user__title\"],[12],[1,\"\\n      \"],[10,1],[15,0,[29,[\"u--ellipsis \",[30,6]]]],[12],[1,\"\\n        \"],[1,[30,1,[\"displayNickname\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[14,0,\"o--user__desc\"],[12],[1,\"\\n      \"],[1,[30,1,[\"accountType\"]]],[1,\"\\n\"],[41,[30,7],[[[1,\"        | \"],[1,[52,[30,1,[\"isLinkedinPersonalProfile\"]],[28,[37,4],[\"shared_words.profile\"],null],[28,[37,4],[\"linkedin.page\"],null]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[18,8,null],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@socialProfile\",\"&attrs\",\"@avatarClass\",\"@showPlatform\",\"@showDetails\",\"@handleQaClass\",\"@showProfileType\",\"&default\"],false,[\"did-insert\",\"if\",\"perform\",\"concat\",\"t\",\"yield\"]]",
    "moduleName": "shared/components/shared/profile-avatar.hbs",
    "isStrictMode": false
  });

  /**
   * @class ProfileAvatar
   * @extends Component
   *
   * This component renders a Social Profile's avatar. This component will
   * automatically try to refresh the social profile if their avatar fails to load.
   * When the secureAvatarUrl changes, the component will try to display the new avatar,
   * and if that fails it will fallback to a default image, or in this case, a dash (-).
   *
   * Required Arguments:
   * - SocialProfile (SocialProfile|Object) A Social profile object that is used to display the correct image and info
   *
   * Optional Arguments:
   * - showPlatform (Boolean) Display an icon of the social profile's platform logo on platform color background.
   * - showDetails (Boolean) Display profile displayname and platform name as strings beside the avatar
   * - showOutline (Boolean) Display outline around avatar image in the color of the social platform
   * - avatarClass (String) A CSS Class to add to the avatar `div`
   * - size (String) The avatar size. Available options: "small", "medium", "large". Defaults to "medium"
   *
   * Examples:
   *
   * Simple Usage:
   * ```
   * <Shared::ProfileAvatar @socialProfile=this.socialProfile />
   * ```
   *
   * Inline Usage with all options:
   * ```
   * <Shared::ProfileAvatar
   *  @size="large"
   *  @avatarClass="u--m__0"
   *  @socialProfile=this.socialProfile
   *  @showPlatform={{true}}
   *  @showDetails={{true}}
   *  @showOutline={{true}}
   * />
   * ```
   *
   * Block Usage:
   * ```
   * <Shared::ProfileAvatar
   *  @size="large"
   *  @socialProfile=this.socialProfile
   * >
   *  <p class="u--text--md u--m__b__0 u--m__t__xs">
   *    custom text
   *  </p>
   * </Shared::ProfileAvatar>
   * ```
   */
  let ProfileAvatar = (_class = class ProfileAvatar extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "isError", _descriptor, this);

      _initializerDefineProperty(this, "_initialAvatarUrl", _descriptor2, this);
    }

    get socialProfile() {
      return this.args.socialProfile;
    }

    get avatarUrl() {
      var _this$socialProfile;

      const url = (_this$socialProfile = this.socialProfile) === null || _this$socialProfile === void 0 ? void 0 : _this$socialProfile.get('secureAvatarUrl');

      if (!this.isError) {
        return url;
      }

      return this._initialAvatarUrl !== url ? url : null;
    }

    get disabledClass() {
      return this.args.isDisabled ? 'u--mute' : '';
    }

    get outlineClass() {
      if (!this.args.showOutline) {
        return '';
      }

      return (0, _profileColorOutlineClass.profileColorOutlineClass)([this.socialProfile.profileColorClass]);
    }

    get sizeClass() {
      const sizeClasses = {
        small: 'o--user--sm',
        medium: 'o--user',
        large: 'o--user--lg',
        default: 'o--user'
      };

      if (this.args.size) {
        return sizeClasses[this.args.size] || sizeClasses.default;
      }

      return sizeClasses.default;
    }

    setInitialAvatarUrl() {
      var _this$socialProfile2;

      this._initialAvatarUrl = (_this$socialProfile2 = this.socialProfile) === null || _this$socialProfile2 === void 0 ? void 0 : _this$socialProfile2.get('secureAvatarUrl');
    }

    *handleError() {
      var _this$socialProfile3;

      this._initialAvatarUrl = (_this$socialProfile3 = this.socialProfile) === null || _this$socialProfile3 === void 0 ? void 0 : _this$socialProfile3.get('secureAvatarUrl');
      this.isError = true;
      const socialProfile = yield (0, _objectPromiseProxy.default)(this.socialProfile);

      if (socialProfile && socialProfile.refreshProfile && typeof socialProfile.refreshProfile === 'function') {
        socialProfile.refreshAndReload.perform();
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_initialAvatarUrl", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "setInitialAvatarUrl", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setInitialAvatarUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleError", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "handleError"), _class.prototype)), _class);
  _exports.default = ProfileAvatar;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProfileAvatar);
});